import React from 'react';

export const LogoTextIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="50" viewBox="0 0 200 50">
            <text x="0" y="35" fontFamily="Arial, sans-serif" fontSize="20" fill="#C7A317">truth</text>
            <text x="40" y="35" fontFamily="Arial, sans-serif" fontSize="20" fill="gray">miner</text>
        </svg>
    )
}